import Vue from 'vue';
import echarts from 'echarts';
import { Component } from 'vue-property-decorator';

@Component({
    components: {
        DirectionalComponent: () => import('../checktask/directionalcheck.vue'),
    }
})
export default class StudyTasksDetailsComponent extends Vue {
    taskList: Array<any> = [];//作业列表
    chechDbList: Array<Object> = [];//普通检测列表
    directionalList: Array<Object> = [];//定向检测列表
    selfCheckList: Array<Object> = [];//作业互查列表
    overViewList: Array<any> = [];//检测结果概况列表
    listLoading: Boolean = false;
    currentPage: number = 1;
    pageSize: number = 10;
    total: number = 10;
    chechDbCurrentPage: number = 1;//普通检测
    chechDbPageSize: number = 10;
    chechDbTotal: number = 10;
    progress: number = 0;//进度
    chechDbListLoading: Boolean = false;
    directionalListLoading: Boolean = false;//定向检测
    directionalCurrentPage: number = 1;
    directionalPageSize: number = 10;
    directionalTotal: number = 10;
    selfCheckListLoading: Boolean = false;//作业互查
    selfCheckCurrentPage: number = 1;
    selfCheckPageSize: number = 10;
    selfCheckTotal: number = 10;
    selfCheckMark: String = 'similarPer';
    overViewListLoading: Boolean = false;//检测结果概况列表
    canSearch: Boolean = true;//能否检索
    eChartIsShow: Boolean = false;//图标是否显示
    eChartBtnText: String = '可视化效果';
    checkTaskId: String = '';//任务id
    fileList: any = [];//上传文件列表
    accountType: string = '';//账号类型
    isShowRecheck: Boolean = false; //是否显示作业互查重新检测
    selectList: any = [];//学术库、定向检测重新检测选择列表
    fullscreenLoading: Boolean = false;
    loadingText: string = '请稍等';
    restCount: number = 0;//剩余检测余额

    parameters = {
        checkTaskId: '',//任务id
        checkTaskName: '',//任务名称
        activeName: 'task',//tabs默认显示
        selfCheckState: '', //作业互查检测状态
        chechDbState: '',//普通检测状态
        directionalState: '',//定向检测状态
        source:'',//来源
    };

    //查询条件
    searchData = {};
    chechDbSearchData = {
        mark: 'ChechDb'
    };
    directionalSearchData = {
        mark: 'Directional'
    };
    selfCheckSearchData = {
        minSimilarPer: '',
        maxSimilarPer: '',
        homeWorkName: '',
    };
    //关系表
    relationList = {
        task: {
            list: 'taskList',
            load: 'listLoading',
            url: '/api/studytasks/homeworks/',
            currentPage: 'currentPage',
            pageSize: 'pageSize',
            total: 'total',
            searchData: 'searchData',
        },
        chechDb: {
            list: 'chechDbList',
            load: 'chechDbListLoading',
            url: '/api/studytasks/check/checkdbcheck/',
            currentPage: 'chechDbCurrentPage',
            pageSize: 'chechDbPageSize',
            total: 'chechDbTotal',
            searchData: 'chechDbSearchData',
        },
        directional: {
            list: 'directionalList',
            load: 'directionalListLoading',
            url: '/api/studytasks/check/checkdbcheck/',
            currentPage: 'directionalCurrentPage',
            pageSize: 'directionalPageSize',
            total: 'directionalTotal',
            searchData: 'directionalSearchData',
        },
        selfCheck: {
            list: 'selfCheckList',
            load: 'selfCheckListLoading',
            url: '/api/studytasks/check/selfchecklists/',
            currentPage: 'selfCheckCurrentPage',
            pageSize: 'selfCheckPageSize',
            total: 'selfCheckTotal',
            searchData: 'selfCheckSearchData',
        }
    };

    //排序
    sortObj = {
        sortBy: {
            createTime: 0,
            finishTime: 1,
            studentNumber: 2,
            totalSimilar: 3,
        },
        order: {
            ascending: 0,
            descending: 1
        }
    }

    //获取参数
    getParameter() {
        this.parameters = (<any>Object).assign({}, this.$route.query);
        let parameter = this.parameters;
        this.checkTaskId = parameter.checkTaskId;
        this.getOverViewList(parameter.checkTaskId);
    }

    //切换tabs
    changeTabs(val) {
        this.selectList = [];//变量初始化
        if (val == 'selfCheck' || val == 'task') {
            this.checkSelfStatus();
            this.getOverViewList(this.parameters.checkTaskId);
        }
        this.selfCheckSearchData.maxSimilarPer = '';
        this.selfCheckSearchData.minSimilarPer = '';
    }

    //学术库、定向检测的重新检测
    reCheckDirectional(type) {
        // 交易失败，余额不足，增加余额判断
        let isRestCount = false;
        let selectCountList = [];
        this.selectList.forEach(item => {
            if (type == 'chechDb') {
                if (item.checkDBStatus == 'TransFailed' || item.checkDBStatus == 'OutOfMoney') {
                    isRestCount = true;
                    selectCountList.push(item);
                }
            } else {
                if (item.singleMultipleStatus == 'TransFailed' || item.singleMultipleStatus == 'OutOfMoney') {
                    isRestCount = true;
                    selectCountList.push(item);
                }
            }
        })
        if (isRestCount) {
            let checkCost = selectCountList.length * 10;
            if (this.restCount < checkCost) {
                this.$alert('剩余检测金额小于本次需要的检测金额', '提示').catch(() => { });
                return false;
            }
        }

        let checkStatus = false;
        let checkstatusList = ['NoCheck', 'Checking', 'Checked','Success'];
        this.selectList.forEach(item => {
            if (checkstatusList.indexOf(type == 'chechDb' ? item.checkDBStatus : item.singleMultipleStatus) != -1) {
                checkStatus = true;
            }
        })
        if (checkStatus) {
            this.$alert('检测状态为“未检测、等待检测、检测完成、检测成功”的不能重新检测', '提示').catch(() => { });
            return false;
        }
        let para = {
            checkTaskId: this.parameters.checkTaskId,
            checkItemIds: []
        };
        para.checkItemIds = this.checkItemIds(this.selectList);
        this.fullscreenLoading = true;
        let url = type == 'chechDb' ? '/api/studytasks/recheck/wfcheckbyitemids' : '/api/studytasks/recheck/singlemultiplebyitemids';
        this.axios.post(url, para).then((data) => {
            this.fullscreenLoading = false;
            let datas = data.data;
            if (datas === 'TransFailed') {
                this.$alert('交易失败', '提示').catch(() => {});
                return false;
            } else if (datas === 'OutOfMoney') {
                this.$alert('余额不足', '提示').catch(() => {});
                return false;
            }
            this.$message({
                message: '重检成功',
                type: 'success'
            });
            this.getList(this.parameters.checkTaskId, type);
        })
    }
    checkItemIds(arr) {
        let list = [];
        for (var i = 0; i < arr.length; i++) {
            list.push(arr[i].checkItemId);
        }
        return list;
    }

    //作业互查重新检测
    reCheck() {
        // 交易失败，余额不足，增加余额判断
        let isRestCount = false;
        this.taskList.forEach(item => {
            if (item.eachOtherStatus == 'TransFailed' || item.eachOtherStatus == 'OutOfMoney') {
                isRestCount = true;
            }
        })
        if (isRestCount) {
            let checkCost = this.taskList.length * 10;
            if (this.restCount < checkCost) {
                this.$alert('剩余检测金额小于本次需要的检测金额', '提示').catch(() => { });
                return false;
            }
        }

        this.fullscreenLoading = true;
        this.axios.get('/api/studytasks/recheckeachother/' + this.parameters.checkTaskId).then((data,err) => {
            this.fullscreenLoading = false;
            let datas = data.data;
            if (datas === 'TransFailed') {
                this.$alert('交易失败', '提示').catch(() => { });
                return false;
            } else if (datas === 'OutOfMoney') {
                this.$alert('余额不足', '提示').catch(() => { });
                return false;
            }
            if (datas == '') {
                this.isShowRecheck = false;
            } else {
                this.$alert(datas, '提示');
                return false;
            }
        })
    }

    //检查作业互查状态
    checkSelfStatus() {
        this.axios.get('/api/studytasks/check/checkstateisfailed/' + this.parameters.checkTaskId).then((data) => {
            if (data.data == 1) {
                this.isShowRecheck = true;
            }
        })
    }

    //学术库、定向检测复选框
    handleSelectionChange(row) {
        this.selectList = row;
    }

    //获取作业/普通检测/定向检测列表/作业互查
    getList(checkTaskId = this.parameters.checkTaskId, mark) {
        this.linkage('minSimilarPer', 'maxSimilarPer');
        if (!this.canSearch) {
            this.$alert('相似比最大值不能小于相似比最小值', '提示');
            return false;
        }
        let obj = this.relationList[mark];
        this[obj.list].length == 0&&(this[obj.load] = true);
        this[obj.load] = true;
        let para = (<any>Object).assign({}, this[obj.searchData]);
        para.offset = (this[obj.currentPage] - 1) * this[obj.pageSize];
        para.limit = this[obj.pageSize];
        para.studyTaskId = checkTaskId;
        let options = {
            params: para
        };
        this.axios.get(obj.url + checkTaskId, options).then((data) => {
            let datas = data.data;
            this[obj.total] = datas.total;
            this[obj.load] = false;
            mark == 'chechDb' &&(this.progress = datas.progress);
            this[obj.list] = datas.data;
        })
    }

    //获取检测结果概况列表
    getOverViewList(checkTaskId) {
        this.overViewListLoading = true;
        this.axios.get('/api/studytasks/check/overview/' + checkTaskId).then((data) => {
            let datas = data.data;
            this.overViewListLoading = false;
            this.overViewList = datas.data;
        })
    }

    //作业互查检索类型变化
    selfCheckTypeChange(val) {
        this.selfCheckMark = val;
        this.selfCheckSearchData = {
            minSimilarPer: '',
            maxSimilarPer: '',
            homeWorkName: '',
        };
    }
    //按相似比查询
    selfCheckSearchFun(row) {
        let totalSimilar = [];
        row.totalSimilar.split('-').forEach(item => {
            totalSimilar.push(parseInt(item));
        });
        this.selfCheckSearchData = {
            minSimilarPer: totalSimilar[0],
            maxSimilarPer: totalSimilar[1],
            homeWorkName: '',
        };
        this.getList(this.parameters.checkTaskId, 'selfCheck');
    }

    //数据可视化
    eChartShow() {
        if (this.overViewList.length==0) {
            return false;
        }
        this.eChartIsShow = !this.eChartIsShow;
        let dimensionList = [];//维度列表
        let countList = [];//作业数量
        let proportionSimilarList = [];//百分比列表
        this.overViewList.forEach(item => {
            dimensionList.push(item.totalSimilar);
            countList.push(item.count);
            proportionSimilarList.push(parseInt(item.proportionSimilar));
        });

        if (this.eChartIsShow){
            // 基于准备好的dom，初始化echarts实例
            // @ts-ignore
            var myChart = echarts.init(document.getElementById('echart'));

            // 指定图表的配置项和数据
            var option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    },
                    formatter: function (params, ticket, callback) {
                        var res = "占比：" + params[0].value + '%' + '<br/>' + "作业数量：" + params[1].value;
                        return res;
                    }
                },
                toolbox: {
                    feature: {
                        //dataView: { show: true, readOnly: false },
                        //magicType: { show: true, type: ['line', 'bar'] },
                        //restore: { show: true },
                        //saveAsImage: { show: true }
                    }
                },
                legend: {
                    data: ['占比', '作业数量']
                },
                xAxis: [
                    {
                        type: 'category',
                        data: dimensionList,
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '占比',
                        axisLabel: {
                            formatter: '{value} %'
                        }
                    },
                    {
                        type: 'value',
                        name: '作业数量',
                        axisLabel: {
                            formatter: '{value}'
                        }
                    },
                ],
                series: [
                    {
                        name: '占比',
                        type: 'bar',
                        data: proportionSimilarList
                    },
                    {
                        name: '作业数量',
                        type: 'line',
                        yAxisIndex: 1, 
                        data: countList
                    }
                ]
            };

            // 使用刚指定的配置项和数据显示图表。
            // @ts-ignore
            myChart.setOption(option);
        }
        this.eChartBtnText = this.eChartIsShow ? '列表效果' : '可视化效果';
    }

    //设置作业互查、普通检测
    setCheck(type) {
        if (type == 'EachOther' && (this.taskList.length < 2)) {
            this.$alert('大于等于两篇才可以作业互查', '提示').catch(() => { });
            return false;
        }
        let checkCost = this.taskList.length * 10;
        if (this.restCount < checkCost) {
            this.$alert('剩余检测金额小于本次需要的检测金额', '提示').catch(() => { });
            return false;
        }
        let options = {
            params: {
                checkTaskId: this.parameters.checkTaskId,
                checkType: type
            }
        };
        this.axios.get('/api/studytasks/recheck/' + this.parameters.checkTaskId, options).then((data) => {
            let datas = data.data;
            if (datas === 'TransFailed') {
                this.$alert('交易失败', '提示').catch(() => { });
                return false;
            } else if (datas === 'OutOfMoney') {
                this.$alert('余额不足', '提示').catch(() => { });
                return false;
            }
            if (type == 'EachOther') {
                this.parameters.selfCheckState = 'Checking';
                this.getList(this.parameters.checkTaskId, 'selfCheck');
                this.getOverViewList(this.parameters.checkTaskId);
            } else if (type == 'CheckDB') {
                this.parameters.chechDbState = 'Checking';
                this.getList(this.parameters.checkTaskId, 'chechDb');
            }
        })
    }

    //定向检测
    directionalCheck() {
        //显示定向检测
        this.$store.commit({
            type: 'changeDirectionalCheckIsShow',
            directionalCheckIsShow: true,
        });
    }

    //检测报告
    checkreport(homeWorkId,type) {
        this.$router.push({
            path: '/checkreport',
            query: {
                homeWorkId: homeWorkId,
                type: type,
                taskName: this.parameters.checkTaskName
            }
        });
    }

    //监听子组件
    checkSuccess(data) {
        if (data == 'success') {
            this.getList(this.parameters.checkTaskId, 'directional');
            this.parameters.directionalState = 'Checking';
        }
    }

    //联动
    linkage(min, max) {
        let minData = Number(this.selfCheckSearchData[min]);
        let maxData = Number(this.selfCheckSearchData[max]);
        if (this.selfCheckSearchData[min] != '' && (!(minData >= 0 && minData <= 100))) {
            this.$alert('请输入0-100间的数字', '提示');
            this.canSearch = false;
        }
        if (this.selfCheckSearchData[max] != '' && (!(maxData >= 0 && maxData <= 100))) {
            this.$alert('请输入0-100间的数字', '提示');
            this.canSearch = false;
        }
        if (minData > maxData && this.canSearch && this.selfCheckSearchData[max] != '' && this.selfCheckSearchData[min] != '') {
            this.$alert('相似比最大值不能小于相似比最小值', '提示');
            this.canSearch = false;
        } else {
            this.canSearch = true;
        }
    }
    //获取余额
    getRestCount() {
        this.axios.get('/api/studytasks/getcheckcount').then((data) => {
            this.restCount = data.data;
        })
    }

    //导出
    exportFile() {
        let para = (<any>Object).assign({}, this.selfCheckSearchData);
        para.checkTaskId = this.parameters.checkTaskId;
        let url = this.utilFun.formatUrl(para, '/api/studytasks/check/eachother/export', '/hw');
        this.utilFun.exportFiles(url);
    }

    //排序
    sortChange(val,type) {
        let obj = this.relationList[type];
        this[obj.searchData].sortBy = this.sortObj.sortBy[val.prop];
        this[obj.searchData].order = this.sortObj.order[val.order];
        this[obj.currentPage] = 1;
        this.getList(this.parameters.checkTaskId, type);
    }

    //跳转
    toUrl(path) {
        this.$router.push({
            path: path,
        });
    }

    //pageSize触发事件
    handleSizeChange(val, mark) {
        let obj = this.relationList[mark];
        this[obj.pageSize] = val;
        this[obj.currentPage] = 1;
        this.getList(this.parameters.checkTaskId, mark);
    }
    //跳转页面触发事件
    handleCurrentChange(val, mark) {
        let obj = this.relationList[mark];
        this[obj.currentPage] = val;
        this.getList(this.parameters.checkTaskId, mark);
    }

    mounted() {
        this.accountType = JSON.parse(localStorage.getItem('access-user')).accountType;
        this.getParameter();
        this.checkSelfStatus();
        this.getRestCount();

        // element-ui 2.4.5存在sort-change在加载时触发的情况，但其实官方认为这是个bug，已在后续版本修复
        // 之前的代码利用了这个bug，使其在加载时自动调用sortChange加载数据
        // 但后续理论上兼容版本（^2.4.5）修复了这个bug，所以导致加载时数据未加载
        // 这里需要手工调用下，还挺难办，这里有4个tab和表格，之前是哪个表格if=true，哪个表格加载数据
        // sortable的用法有些问题
        // 另外sortChange的逻辑应该加到getList（loadData）才对
    }
}
